import React, { useEffect, useState } from 'react';
import { fetchExamTopics } from '../../api/fetchExam';
import Neirotopics from '../../components/Neirotopics/Neirotopics';
import { useDelayedLoading } from '../../hooks/useDelayedLoading';
import Loading from '../../components/Loading/Loading';
import { useAppConfig } from '../../context/AppConfigContext';
import Modal from '../../components/Modal';
import ExamResult from './ExamResult';

function ExamList({ onExamSelect, userId }) {
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pendingResult, setPendingResult] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(null);
  const { t } = useAppConfig();
  const showLoading = useDelayedLoading(loading, 3000);

  useEffect(() => {
    fetchExamTopics({ userId })
      .then((data) => {
        setTopics(data.exams);
        if (data.pendingResult) {
          setPendingResult(data.pendingResult);
          setShowModal(true);
        }
      })
      .catch((err) => {
        setError(err.toString());
      })
      .finally(() => {
        setLoading(false);
      });
  }, [userId]);

  if (showLoading) {
    return <Loading />;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

	if (pendingResult && showModal) {
	  return (
		<Modal
		  title={t.examBlock.modalNoticeTitle}
		  confirmText={t.examBlock.modalNoticeConfirm}
		  onConfirm={() => setShowModal(false)}
		  onClose={() => setShowModal(false)}
		  hideCancel={true}
		>
		  <p>{t.examBlock.modalNoticeText}</p>
		</Modal>
	  );
	}

  if (pendingResult && !showModal) {
    return (
      <ExamResult
        result={pendingResult}
        onComplete={() => {
          setPendingResult(null);
        }}
      />
    );
  }
  return (
    <Neirotopics data={topics} onSelect={onExamSelect} neirotitle={t.examBlock.menu} source="exam" />
  );
}

export default ExamList;